import * as React from 'react';
import * as ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import diyLightTheme = require('diy/material-ui/diyLightTheme');

import {GuidanceDialog, GuidanceDialogProps} from './components/GuidanceDialog';

let dialogContainer: HTMLElement;

export function showDialog(options: GuidanceDialogProps) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'diy-sections-guidance-dialog';
    document.body.appendChild(dialogContainer);
    ReactDOM.render(
        <MuiThemeProvider muiTheme={diyLightTheme}>
            <GuidanceDialog {...options} />
        </MuiThemeProvider>,
        dialogContainer
    );
}

export function hideDialog() {
    if (dialogContainer) {
        ReactDOM.unmountComponentAtNode(dialogContainer);
        dialogContainer.parentElement.removeChild(dialogContainer);
        dialogContainer = null;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/guidanceDialog.tsx
 **/